import { Suspense } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../auth/AuthProvider'
import { AppLayout } from './AppLayout'
import { Loading } from '../feedback/Loading'

/** Envoltura de rutas protegidas: exige sesión; si no hay, redirige a /login. */
export function ProtectedLayout() {
  const { isAuthenticated, initializing } = useAuth()
  const location = useLocation()

  if (initializing) {
    return <Loading label="Cargando…" />
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  return (
    <AppLayout>
      <Suspense fallback={<Loading label="Cargando vista…" />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  )
}
